import {auth} from "../../../Auth"

export default function permissions () {
  const permissions = []

  if (!['admin', 'super-admin'].includes(auth.sunkaizenUser.type)) {
    permissions.push({term: {[`permissions.${auth.sunkaizenUser.id}.sortable`]: 'Unead'}})
  }
  return permissions
}